import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlusBoxStack24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPlusBoxStack24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.25 4.5h8.5c.966 0 1.75.784 1.75 1.75v8.5a1.75 1.75 0 0 1-1.5 1.732V9.25A3.25 3.25 0 0 0 14.75 6H7.518A1.75 1.75 0 0 1 9.25 4.5M21 14.75a3.25 3.25 0 0 1-3.009 3.241A3.25 3.25 0 0 1 14.75 21h-8.5A3.25 3.25 0 0 1 3 17.75v-8.5a3.25 3.25 0 0 1 3.009-3.241A3.25 3.25 0 0 1 9.25 3h8.5A3.25 3.25 0 0 1 21 6.25zM14.75 7.5h-8.5A1.75 1.75 0 0 0 4.5 9.25v8.5c0 .966.784 1.75 1.75 1.75h8.5a1.75 1.75 0 0 0 1.75-1.75v-8.5a1.75 1.75 0 0 0-1.75-1.75M10.5 10a.75.75 0 0 1 .75.75v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlusBoxStack24);
